@import "../../global/gx-ide-mixins.scss";
@import "../../global/temporary-mercury-overrides/_button.scss";

:host {
  display: grid;
  block-size: 100%;
  grid-template:
    "header header" max-content
    "objects-in-file import-status" 1fr
    "footer footer" max-content;
  grid-template-columns: 1fr 1fr;
}

.section {
  display: contents;
}

// header
.header {
  grid-template-columns: 1fr max-content;
  grid-area: header;
}

// objects in file
.objects-in-file__section {
  grid-area: objects-in-file;
}
.objects-in-file__main {
  border-inline-end: var(--section-common-border);
  grid-template-rows: 1fr max-content;
}
.objects-in-file__footer {
  display: grid;
}

// import status
.import-status__section {
  grid-area: import-status;
}
.import-status__main {
  grid-template-rows: 1fr max-content;
}
.import-status__footer {
  display: flex;
}
.import-clear-status-btn {
  margin-inline-start: auto;
}

// objects in file & import status
.objects-in-file__section,
.import-status__section {
  display: grid;
  grid-template-rows: max-content 1fr;
}
.dialog-header__objects-in-file,
.dialog-header__import-status {
  padding-block-start: 16px;
}
.objects-in-file__main,
.import-status__main {
  grid-auto-rows: max-content;
  padding-block: 12px;
  overflow: auto;
}

// footer
.footer {
  display: flex;
  grid-area: footer;
  border-block-start: var(--section-common-border);
}

// WA / TODO: Add a helper class in Mercury to justify text.
.text-align-center {
  text-align: center; // should be resolved on mercury
}

.tree-view::part(item__action tree-view-item--status) {
  grid-template: "first-img left-img text right-img" / max-content max-content 1fr max-content;
  &::before {
    grid-area: first-img;
    content: "";
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: var(--gray-03);
    margin-inline-end: 2px;
  }
}

.tree-view::part(item__action tree-view-item--success) {
  @include tree-item-status("success");
}
.tree-view::part(item__action tree-view-item--warning) {
  @include tree-item-status("warning");
}
.tree-view::part(item__action tree-view-item--error) {
  @include tree-item-status("error");
}

// WA: prevent crashes when the items collection contains too many elements
.tree-view-import::part(item) {
  content-visibility: auto;
  contain-intrinsic-size: auto 22px;
  // TODO: Check if 22px can be calculated. Not "secure" since font-size
  // (body-regular-s) defines the total height. If the typographic style
  // changes, this calculation will break. Ideally, tree item font-size
  // should use a variable like "--tree-item-font-size".
}
